import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";

const extractJobDescriptionFromUrlSchema = z.object({
  url: z.string().url(),
});

export class ExtractJobDescriptionFromUrlDto extends createZodDto(
  extractJobDescriptionFromUrlSchema,
) {}
